<template>
    <core-view class="flex-column" fill-height>

        <v-container class="pa-4">

          <v-row dense class=" mb-1">
            <v-col cols="12">
              <div class="section-banner banner-blue white--text text-uppercase font-weight-bold px-4 py-2 rounded-lg elevation-1">
                <v-icon left color="white">mdi-cart-outline</v-icon>
                Pedidos
              </div>
            </v-col>
          </v-row>
          
          <!-- PRIMEIRA PARTE: PEDIDOS -->
          <v-row dense>
            <v-col cols="4">
              <v-card 
                :to="{ path: '/diversos_resumo', query: { relatorio: 'TabelaPedidos', ...$route.query } }"
                height="100%" 
                class="d-flex flex-column align-center justify-center text-center py-4 dashboard-card rounded-lg elevation-2 position-relative overflow-hidden"
              >
                <v-icon class="watermark-icon">mdi-clipboard-text-outline</v-icon>
                <span class="text-caption text-uppercase font-weight-bold text--secondary mb-1 z-index-1">Realizados</span>
                <span class="text-h6 font-weight-bold text--primary z-index-1">{{ dashboard.totalPedidos }}</span>
                <span class="text-body-2 font-weight-medium text--primary mt-1 z-index-1"> {{ dashboard.valorTotalPedidos }}</span>
              </v-card>
            </v-col>

            <v-col cols="4">
              <v-card 
                :to="{ path: '/diversos_resumo', query: { relatorio: 'TabelaPedidos', tipo: 'faturados', ...$route.query } }"
                height="100%" 
                class="d-flex flex-column align-center justify-center text-center py-4 dashboard-card rounded-lg elevation-2 position-relative overflow-hidden"
              >
                <v-icon class="watermark-icon">mdi-check-decagram-outline</v-icon>
                <span class="text-caption text-uppercase font-weight-bold text--secondary mb-1 z-index-1">Faturados</span>
                <span class="text-h6 font-weight-bold text--primary z-index-1">{{ dashboard.faturados }}</span>
                <span class="text-body-2 font-weight-medium text--primary mt-1 z-index-1"> {{ dashboard.valorFaturados }}</span>
              </v-card>
            </v-col>

            <v-col cols="4">
              <v-card 
                :to="{ path: '/diversos_resumo', query: { relatorio: 'TabelaPedidos', tipo: 'a-faturar', ...$route.query } }"
                height="100%" 
                class="d-flex flex-column align-center justify-center text-center py-4 dashboard-card rounded-lg elevation-2 position-relative overflow-hidden"
              >
                <v-icon class="watermark-icon">mdi-clock-outline</v-icon>
                <span class="text-caption text-uppercase font-weight-bold text--secondary mb-1 z-index-1">A Faturar</span>
                <span class="text-h6 font-weight-bold text--primary z-index-1">{{ dashboard.aFaturar }}</span>
                <span class="text-body-2 font-weight-medium text--primary mt-1 z-index-1"> {{ dashboard.valorAFaturar }}</span>
              </v-card>
            </v-col>
          </v-row>

          <v-row dense class="mt-5 mb-1">
            <v-col cols="12">
              <div class="section-banner banner-amber white--text text-uppercase font-weight-bold px-4 py-2 rounded-lg elevation-1">
                <v-icon left color="white">mdi-file-document-edit-outline</v-icon>
                Orçamentos
              </div>
            </v-col>
          </v-row>

          <!-- SEGUNDA PARTE: ORÇAMENTOS -->
          <v-row dense class="mt-2">
            <v-col cols="4">
              <v-card 
                :to="{ path: '/diversos_resumo', query: { relatorio: 'TabelaOrcamento', ...$route.query } }"
                height="100%" 
                class="d-flex flex-column align-center justify-center text-center py-4 dashboard-card-amber rounded-lg elevation-2 position-relative overflow-hidden"
              >
                <v-icon class="watermark-icon">mdi-file-document-outline</v-icon>
                <span class="text-caption text-uppercase font-weight-bold text--secondary mb-1 z-index-1">Realizados</span>
                <span class="text-h6 font-weight-bold text--primary z-index-1">{{ dashboard.totalOrcamento }}</span>
                <span class="text-body-2 font-weight-medium text--primary mt-1 z-index-1"> {{ dashboard.valorTotalOrcamento }}</span>
              </v-card>
            </v-col>

            <v-col cols="4">
              <v-card 
                :to="{ path: '/diversos_resumo', query: { relatorio: 'TabelaOrcamento', tipo: 'convertidos', ...$route.query } }"
                height="100%" 
                class="d-flex flex-column align-center justify-center text-center py-4 dashboard-card-amber rounded-lg elevation-2 position-relative overflow-hidden"
              >
                <v-icon class="watermark-icon">mdi-handshake-outline</v-icon>
                <span class="text-caption text-uppercase font-weight-bold text--secondary mb-1 z-index-1">Convertidos</span>
                <span class="text-h6 font-weight-bold text--primary z-index-1">{{ dashboard.orcamentoConvertido }}</span>
                <span class="text-body-2 font-weight-medium text--primary mt-1 z-index-1"> {{ dashboard.valorOrcamentoConvertido }}</span>
              </v-card>
            </v-col>

            <v-col cols="4">
              <v-card 
                :to="{ path: '/diversos_resumo', query: { relatorio: 'TabelaOrcamento', tipo: 'a-converter', ...$route.query } }"
                height="100%" 
                class="d-flex flex-column align-center justify-center text-center py-4 dashboard-card-amber rounded-lg elevation-2 position-relative overflow-hidden"
              >
                <v-icon class="watermark-icon">mdi-sync</v-icon>
                <span class="text-caption text-uppercase font-weight-bold text--secondary mb-1 z-index-1">A Converter</span>
                <span class="text-h6 font-weight-bold text--primary z-index-1">{{ dashboard.aConverter }}</span>
                <span class="text-body-2 font-weight-medium text--primary mt-1 z-index-1"> {{ dashboard.valorAConverter }}</span>
              </v-card>
            </v-col>
          </v-row>

          <v-row dense class="mt-5 mb-1">
            <v-col cols="12">
              <div class="section-banner banner-teal white--text text-uppercase font-weight-bold px-4 py-2 rounded-lg elevation-1">
                <v-icon left color="white">mdi-trending-up</v-icon>
                Performance Cliente
              </div>
            </v-col>
          </v-row>

          <!-- TERCEIRA PARTE: CLIENTES -->
          <v-row dense class="mt-2">
            <v-col cols="3">
              <v-card 
                :to="{ path: '/diversos_resumo', query: { relatorio: 'TabelaClientes', tipo: 'novos', ...$route.query } }"
                height="100%" 
                class="d-flex flex-column align-center justify-center text-center py-4 dashboard-card-teal rounded-lg elevation-2 position-relative overflow-hidden"
              >
                <v-icon class="watermark-icon">mdi-account-plus-outline</v-icon>
                <span class="text-caption text-uppercase font-weight-bold text--secondary mb-1 z-index-1">Novos</span>
                <span class="text-h6 font-weight-bold text--primary z-index-1">{{ dashboard.clientesNovos }}</span>
              </v-card>
            </v-col>

            <v-col cols="3">
              <v-card 
                :to="{ path: '/diversos_resumo', query: { relatorio: 'TabelaClientes', tipo: 'novos-com-venda', ...$route.query } }"
                height="100%" 
                class="d-flex flex-column align-center justify-center text-center py-4 dashboard-card-teal rounded-lg elevation-2 position-relative overflow-hidden"
              >
                <v-icon class="watermark-icon">mdi-account-cash-outline</v-icon>
                <span class="text-caption text-uppercase font-weight-bold text--secondary mb-1 z-index-1">Com Venda</span>
                <span class="text-h6 font-weight-bold text--primary z-index-1">{{ dashboard.clientesNovosComVenda }}</span>
              </v-card>
            </v-col>

            <v-col cols="3">
              <v-card 
                :to="{ path: '/diversos_resumo', query: { relatorio: 'TabelaClientes', ...$route.query } }"
                height="100%" 
                class="d-flex flex-column align-center justify-center text-center py-4 dashboard-card-teal rounded-lg elevation-2 position-relative overflow-hidden"
              >
                <v-icon class="watermark-icon">mdi-folder-account-outline</v-icon>
                <span class="text-caption text-uppercase font-weight-bold text--secondary mb-1 z-index-1">Carteira</span>
                <span class="text-h6 font-weight-bold text--primary z-index-1">{{ dashboard.carteiraAtiva }}</span>
              </v-card>
            </v-col>

            <v-col cols="3">
              <v-card 
                :to="{ path: '/diversos_resumo', query: { relatorio: 'ResumoVendasCliente', ...$route.query } }" 
                height="100%" 
                class="d-flex flex-column align-center justify-center text-center py-4 dashboard-card-teal rounded-lg elevation-2 position-relative overflow-hidden"
              >
                <v-icon class="watermark-icon">mdi-folder-plus-outline</v-icon>
                <span class="text-caption text-uppercase font-weight-bold text--secondary mb-1 z-index-1">Com Venda</span>
                <span class="text-h6 font-weight-bold text--primary z-index-1">{{ dashboard.carteiraComVenda }}</span>
              </v-card>
            </v-col>
            </v-row>

            <v-row dense justify="center" class="mt-2">
            <v-col cols="6">
              <v-card 
                :to="{ path: '/diversos_resumo', query: { relatorio: 'TabelaClientes', tipo: 'sem-venda', ...$route.query } }"
                height="100%" 
                class="d-flex flex-column align-center justify-center text-center py-4 dashboard-card-teal rounded-lg elevation-2 position-relative overflow-hidden"
              >
                <v-icon class="watermark-icon">mdi-folder-remove-outline</v-icon>
                <span class="text-caption text-uppercase font-weight-bold text--secondary mb-1 z-index-1">Sem Venda</span>

                <span class="text-h6 font-weight-bold text--primary z-index-1">{{ dashboard.carteiraSemVenda }}</span>
              </v-card>
            </v-col>
            </v-row>

          <!-- TICKET MÉDIO -->
          <v-card dark class="mt-5 pa-5 rounded-lg d-flex justify-space-between align-center ticket-card elevation-3 position-relative overflow-hidden">
            <v-icon class="ticket-watermark">mdi-cash-multiple</v-icon>
            
            <div class="d-flex align-center z-index-1">
              <v-icon color="white" class="mr-3" size="32">mdi-cash-multiple</v-icon>
              <span class="text-subtitle-1 font-weight-medium">Ticket médio</span>
            </div>
            <span class="text-h4 font-weight-bold z-index-1"> {{ dashboard.ticketMedio }}</span>
          </v-card>

          <!-- PROGRESSO META MENSAL -->
          <v-card class="mt-6 pa-5 rounded-lg elevation-2 bg-white hover-card">
            <div class="text-h6 font-weight-bold text--primary mb-5 d-flex align-center">
              <v-icon color="primary" class="mr-2">mdi-target-arrow</v-icon>
              Progresso da Meta Mensal
            </div>
            
            <div class="d-flex align-center flex-wrap gap-4">
              <v-progress-circular
                :size="120"
                :width="14"
                :value="dashboard.metaPercentual"
                :color="$_getCorMeta(dashboard.metaPercentual)"
                class="progress-bg"
              >
                <span class="text-h5 font-weight-bold text--primary">{{ dashboard.metaPercentual }}%</span>
              </v-progress-circular>
              
              <div class="d-flex flex-column justify-center ml-sm-6 mt-4 mt-sm-0">
                <div class="mb-3">
                  <span class="text-caption text-uppercase font-weight-bold text--secondary d-block">Realizado</span>
                  <span class="text-h6 font-weight-bold" :class="`${$_getCorMeta(dashboard.metaPercentual)}--text`">
                    {{ dashboard.realizadoValor }}
                  </span>
                </div>
                <div>
                  <span class="text-caption text-uppercase font-weight-bold text--secondary d-block">Objetivo</span>
                  <span class="text-subtitle-1 font-weight-medium text--primary"> {{ dashboard.metaValor }}</span>
                </div>
              </div>
            </div>
          </v-card>

          <!-- VENDAS POR CIDADE (CIRCULAR / DONUT) -->
          <v-card class="mt-6 pa-5 rounded-lg elevation-2 bg-white hover-card">
            <div class="d-flex align-center justify-space-between mb-4 flex-wrap gap-2">
              <div class="text-h6 font-weight-bold text--primary d-flex align-center">
                <v-icon color="primary" class="mr-2">mdi-city-variant-outline</v-icon>
                Vendas por Cidade
                <v-chip v-if="dashboardCidades.qtdCidades > 0" x-small color="primary" outlined class="ml-2 font-weight-bold">
                  {{ dashboardCidades.qtdCidades }} {{ dashboardCidades.qtdCidades === 1 ? 'cidade' : 'cidades' }}
                </v-chip>
              </div>

              <v-btn
                text
                small
                color="primary"
                class="text-none font-weight-bold px-1"
                :to="{ path: '/diversos_resumo', query: { relatorio: 'ResumoVendasCidade', ...$route.query } }"
              >
                Ver Todas
                <v-icon small right>mdi-chevron-right</v-icon>
              </v-btn>
            </div>

            <!-- Sem dados -->
            <div v-if="dashboardCidades.itens.length === 0" class="text-center py-6 text--secondary">
              <v-icon size="40" color="grey lighten-1">mdi-map-marker-off-outline</v-icon>
              <div class="text-caption mt-2 font-weight-medium">Nenhuma venda por cidade no período selecionado.</div>
            </div>

            <!-- Gráfico Circular Donut / Pizza com Legenda -->
            <div v-else>
              <div class="d-flex flex-column flex-sm-row align-center justify-space-around py-2">
                <!-- Círculo Donut Multi-Fatias -->
                <div class="donut-chart-wrapper my-3">
                  <div class="donut-chart" :style="{ background: donutGradient }">
                    <div class="donut-hole d-flex flex-column align-center justify-center">
                      <span class="text-caption font-weight-bold text--secondary" style="font-size: 0.65rem !important;">TOTAL</span>
                      <span class="text-caption font-weight-black primary--text" style="font-size: 0.8rem !important; line-height: 1.1;">
                         {{ dashboardCidades.totalGeral }}
                      </span>
                      <span class="text-caption grey--text mt-1" style="font-size: 0.65rem !important;">
                        {{ dashboardCidades.qtdCidades }} {{ dashboardCidades.qtdCidades === 1 ? 'cidade' : 'cidades' }}
                      </span>
                    </div>
                  </div>
                </div>

                <!-- Legenda do Donut com Simplebar -->
                <simplebar :auto-hide="false" style="width: 100%; max-height: 250px;" class="donut-legend flex-grow-1 ml-sm-6 w-100 mt-3 mt-sm-0 px-2">
                  <div
                    v-for="(cidade, idx) in dashboardCidades.itens"
                    :key="idx"
                    class="d-flex align-center justify-space-between py-2 px-1 border-bottom-light"
                  >
                    <div class="d-flex align-center text-truncate mr-2">
                      <span class="legend-indicator mr-2" :style="{ backgroundColor: cidade.cor }"></span>
                      <span class="text-caption font-weight-bold text-truncate text--primary" :title="cidade.nome">
                        {{ cidade.nome }}
                      </span>
                    </div>
                    <div class="text-right flex-shrink-0">
                      <span class="text-caption font-weight-bold text--primary mr-1">
                         {{ cidade.valorFormatado }}
                      </span>
                      <span class="text-caption font-weight-bold" :style="{ color: cidade.cor }">
                        {{ cidade.percentual }}%
                      </span>
                    </div>
                  </div>
                </simplebar>
              </div>

              <!-- Rodapé do Card -->
              <v-divider class="my-3"></v-divider>
              <div class="d-flex justify-space-between align-center text-caption font-weight-bold text--secondary">
                <span>Total faturado no período:</span>
                <span class="text-subtitle-2 font-weight-bold primary--text">
                   {{ dashboardCidades.totalGeral }}
                </span>
              </div>
            </div>
          </v-card>

          <!-- VENDAS POR GRUPO DE PRODUTOS (COLUNAS VERTICAIS) -->
          <v-card class="mt-6 pa-5 rounded-lg elevation-2 bg-white hover-card">
            <div class="d-flex align-center justify-space-between mb-4 flex-wrap gap-2">
              <div class="text-h6 font-weight-bold text--primary d-flex align-center">
                <v-icon color="primary" class="mr-2">mdi-shape-outline</v-icon>
                Vendas por Grupo
                <v-chip v-if="dashboardGrupos.qtdGrupos > 0" x-small color="primary" outlined class="ml-2 font-weight-bold">
                  {{ dashboardGrupos.qtdGrupos }} {{ dashboardGrupos.qtdGrupos === 1 ? 'grupo' : 'grupos' }}
                </v-chip>
              </div>

              <v-btn
                text
                small
                color="primary"
                class="text-none font-weight-bold px-1"
                :to="{ path: '/diversos_resumo', query: { relatorio: 'ResumoVendasGrupo', ...$route.query } }"
              >
                Ver Todos
                <v-icon small right>mdi-chevron-right</v-icon>
              </v-btn>
            </div>

            <!-- Sem dados -->
            <div v-if="dashboardGrupos.itens.length === 0" class="text-center py-6 text--secondary">
              <v-icon size="40" color="grey lighten-1">mdi-package-variant-closed-remove</v-icon>
              <div class="text-caption mt-2 font-weight-medium">Nenhuma venda por grupo no período selecionado.</div>
            </div>

            <!-- Gráfico de Colunas Verticais com Simplebar -->
            <div v-else>
              <simplebar :auto-hide="false" style="width: 100%;" class="vertical-chart-wrapper py-2">
                <div class="vertical-bars-container">
                  <div
                    v-for="(grupo, idx) in dashboardGrupos.itensVerticais"
                    :key="idx"
                    class="vertical-bar-item"
                  >
                    <!-- Valor no topo da barra -->
                    <span class="vertical-bar-val text-caption font-weight-bold" :style="{ color: grupo.cor }">
                      {{ grupo.valorAbreviado }}
                    </span>

                    <!-- Track e Coluna -->
                    <div class="vertical-bar-track">
                      <div
                        class="vertical-bar-fill"
                        :style="{
                          height: `${grupo.alturaRelativa}%`,
                          background: `linear-gradient(180deg, ${grupo.cor} 0%, ${grupo.cor}cc 100%)`
                        }"
                        :title="`${grupo.nome}:  ${grupo.valorFormatado} (${grupo.percentual}%)`"
                      >
                        <span v-if="grupo.alturaRelativa >= 28" class="vertical-bar-inner-percent">
                          {{ grupo.percentual }}%
                        </span>
                      </div>
                    </div>

                    <!-- Nome do Grupo -->
                    <div class="vertical-bar-label" :title="grupo.nome">
                      <span class="text-caption font-weight-bold text-truncate d-block text--primary" style="font-size: 0.72rem !important;">
                        {{ grupo.nomeCurto }}
                      </span>
                      <span class="text-caption grey--text d-block" style="font-size: 0.65rem !important;">
                        {{ grupo.percentual }}%
                      </span>
                    </div>
                  </div>
                </div>
              </simplebar>

              <!-- Rodapé do Card -->
              <v-divider class="my-3"></v-divider>
              <div class="d-flex justify-space-between align-center text-caption font-weight-bold text--secondary">
                <span>Total faturado em grupos no período:</span>
                <span class="text-subtitle-2 font-weight-bold primary--text">
                   {{ dashboardGrupos.totalGeral }}
                </span>
              </div>
            </div>
          </v-card>

          <!-- VENDAS POR MARCA DE PRODUTOS (BARRAS HORIZONTAIS) -->
          <v-card class="mt-6 pa-5 rounded-lg elevation-2 bg-white hover-card">
            <div class="d-flex align-center justify-space-between mb-4 flex-wrap gap-2">
              <div class="text-h6 font-weight-bold text--primary d-flex align-center">
                <v-icon color="primary" class="mr-2">mdi-tag-multiple-outline</v-icon>
                Vendas por Marca
                <v-chip v-if="dashboardMarcas.qtdMarcas > 0" x-small color="primary" outlined class="ml-2 font-weight-bold">
                  {{ dashboardMarcas.qtdMarcas }} {{ dashboardMarcas.qtdMarcas === 1 ? 'marca' : 'marcas' }}
                </v-chip>
              </div>
            </div>

            <!-- Sem dados -->
            <div v-if="dashboardMarcas.itens.length === 0" class="text-center py-6 text--secondary">
              <v-icon size="40" color="grey lighten-1">mdi-tag-off-outline</v-icon>
              <div class="text-caption mt-2 font-weight-medium">Nenhuma venda por marca no período selecionado.</div>
            </div>

            <!-- Gráfico de Barras Horizontais com Simplebar -->
            <div v-else>
              <simplebar :auto-hide="false" style="max-height: 280px;" class="marcas-scroll-wrapper px-2">
                <div
                  v-for="(marca, idx) in dashboardMarcas.itens"
                  :key="idx"
                  class="mb-3 px-1"
                >
                  <div class="d-flex justify-space-between align-center mb-1">
                    <div class="d-flex align-center text-truncate mr-2">
                      <span 
                        class="rank-badge mr-2"
                        :style="{ backgroundColor: marca.cor }"
                      >
                        {{ marca.posicao }}
                      </span>
                      <span class="text-body-2 font-weight-bold text-truncate text--primary">
                        {{ marca.nome }}
                      </span>
                    </div>
                    <div class="text-right flex-shrink-0">
                      <span class="text-body-2 font-weight-bold text--primary mr-1">
                         {{ marca.valorFormatado }}
                      </span>
                      <span class="text-caption font-weight-bold text--secondary">
                        ({{ marca.percentual }}%)
                      </span>
                    </div>
                  </div>
                  <v-progress-linear
                    :value="marca.percentualNum"
                    :color="marca.cor"
                    height="7"
                    rounded
                    background-color="grey lighten-3"
                  ></v-progress-linear>
                </div>
              </simplebar>

              <!-- Rodapé do Card -->
              <v-divider class="my-3"></v-divider>
              <div class="d-flex justify-space-between align-center text-caption font-weight-bold text--secondary">
                <span>Total faturado em marcas no período:</span>
                <span class="text-subtitle-2 font-weight-bold primary--text">
                   {{ dashboardMarcas.totalGeral }}
                </span>
              </div>
            </div>
          </v-card>
        </v-container>
    </core-view>
</template>

<script>
import CoreView from '@/components/core/view/Index.vue';
import simplebar from 'simplebar-vue';
import 'simplebar-vue/dist/simplebar.min.css';
import { TOKEN, VENDEDOR_STORAGE } from '@/constants/STORAGE';
import db from '@/plugins/dexie';
import { HOME_QUERIES } from '@/constants/QUERY_FILTERS';
import { getQueryValue } from '@/services/query-string';

function getSessionStorage(key, defaultValue) {
  return sessionStorage.getItem(key) ?? defaultValue;
}

export default {
  name: 'ViewHome',

  components: {
    CoreView,
    simplebar,
  },

  data() {
    return {
      snackbar: true,
      snackbarSucesso: false,
      alwaysTrue: true,
      debug: [],
      debugData: [],
      idVendedorLogado: null,
      idEmpresaLogada: null,
      dashboard: {    
        // Pedidos
        totalPedidos: 0,
        valorTotalPedidos: '0,00', 
        faturados: 0,
        valorFaturados: '0,00',
        aFaturar: 0,
        valorAFaturar: '0,00',

        // Orçamentos
        totalOrcamento: 0,
        valorTotalOrcamento: '0,00', 
        orcamentoConvertido: 0,
        valorOrcamentoConvertido: '0,00',
        aConverter: 0,
        valorAConverter: '0,00',

        // Clientes
        clientesNovos: 0,
        clientesNovosComVenda: 0,
        carteiraAtiva: 0,
        carteiraComVenda: 0,
        carteiraSemVenda: 0,

        // Indicadores e Metas
        ticketMedio: '0,00',
        metaPercentual: 0,
        metaValor: '0,00',
        realizadoValor: '0,00'
      },
      dashboardCidades: {
        totalGeral: '0,00',
        qtdCidades: 0,
        itens: [],
        itensVerticais: []
      },
      tipoGraficoCidade: 'vertical',
      dashboardGrupos: {
        totalGeral: '0,00',
        qtdGrupos: 0,
        itens: [],
        itensVerticais: []
      },
      tipoGraficoGrupo: 'vertical',
      dashboardMarcas: {
        totalGeral: '0,00',
        qtdMarcas: 0,
        itens: [],
        itensVerticais: []
      },
      tipoGraficoMarca: 'vertical'
    };
  },

  computed: {
    donutGradient() {
      if (!this.dashboardCidades.itens || this.dashboardCidades.itens.length === 0) {
        return 'conic-gradient(#dee2e6 0% 100%)';
      }
      let acumulado = 0;
      const slices = [];
      this.dashboardCidades.itens.forEach(item => {
        const perc = parseFloat(item.percentualNum) || 0;
        if (perc <= 0) return;
        const inicio = acumulado;
        acumulado += perc;
        const fim = Math.min(acumulado, 100);
        slices.push(`${item.cor} ${inicio.toFixed(2)}% ${fim.toFixed(2)}%`);
      });
      if (slices.length === 0) {
        return 'conic-gradient(#dee2e6 0% 100%)';
      }
      if (acumulado < 100) {
        slices.push(`#e2e8f0 ${acumulado.toFixed(2)}% 100%`);
      }
      return `conic-gradient(${slices.join(', ')})`;
    },

    donutGradientGrupo() {
      if (!this.dashboardGrupos.itens || this.dashboardGrupos.itens.length === 0) {
        return 'conic-gradient(#dee2e6 0% 100%)';
      }
      let acumulado = 0;
      const slices = [];
      this.dashboardGrupos.itens.forEach(item => {
        const perc = parseFloat(item.percentualNum) || 0;
        if (perc <= 0) return;
        const inicio = acumulado;
        acumulado += perc;
        const fim = Math.min(acumulado, 100);
        slices.push(`${item.cor} ${inicio.toFixed(2)}% ${fim.toFixed(2)}%`);
      });
      if (slices.length === 0) {
        return 'conic-gradient(#dee2e6 0% 100%)';
      }
      if (acumulado < 100) {
        slices.push(`#e2e8f0 ${acumulado.toFixed(2)}% 100%`);
      }
      return `conic-gradient(${slices.join(', ')})`;
    },

    donutGradientMarca() {
      if (!this.dashboardMarcas.itens || this.dashboardMarcas.itens.length === 0) {
        return 'conic-gradient(#dee2e6 0% 100%)';
      }
      let acumulado = 0;
      const slices = [];
      this.dashboardMarcas.itens.forEach(item => {
        const perc = parseFloat(item.percentualNum) || 0;
        if (perc <= 0) return;
        const inicio = acumulado;
        acumulado += perc;
        const fim = Math.min(acumulado, 100);
        slices.push(`${item.cor} ${inicio.toFixed(2)}% ${fim.toFixed(2)}%`);
      });
      if (slices.length === 0) {
        return 'conic-gradient(#dee2e6 0% 100%)';
      }
      if (acumulado < 100) {
        slices.push(`#e2e8f0 ${acumulado.toFixed(2)}% 100%`);
      }
      return `conic-gradient(${slices.join(', ')})`;
    }
  },

  watch: {
    '$route.query': {
      deep: true,
      handler() {
        if(this.idVendedorLogado) {
          this.$_recarregarDashboard();
        }
      }
    }
  },

  methods: {
    $_getCorMeta(percentual) {
      if (percentual >= 100) return 'success';
      if (percentual >= 50) return 'primary';
      return 'warning';
    },

    async $_recarregarDashboard() {
      this.$_carregarTotalPedidos();
      this.$_carregarTotalOrcamento();
      this.$_carregarOrcamentoConvertido();
      this.$_carregarPedidosFaturados();
      this.$_carregarTicketMedio();
      this.$_carregarMetaMensal();

      this.$_carregarPedidosAFaturar();
      this.$_carregarOrcamentosAConverter();
      this.$_carregarMetricasClientes();
      this.$_carregarVendasPorCidade();
      this.$_carregarVendasPorGrupo();
      this.$_carregarVendasPorMarca();
    },

    $_dentroDoPeriodo(pedido, campoData = 'data') {
      const createdFrom = getQueryValue(HOME_QUERIES.createdFrom);
      const createdBefore = getQueryValue(HOME_QUERIES.createdBefore);

      const dataAtual = new Date();
      const hoje = dataAtual.toISOString().split('T')[0];
      const ano = dataAtual.getFullYear();
      const mes = String(dataAtual.getMonth() + 1).padStart(2, '0');
      const primeiroDiaMes = `${ano}-${mes}-01`;

      const inicio = createdFrom || primeiroDiaMes;
      const fim = createdBefore || hoje;

      const dataDoPedido = pedido[campoData]; 
      if (!dataDoPedido) return false;

      try {
        let dataFormatada = '';
        if (dataDoPedido instanceof Date) {
          const ano = dataDoPedido.getFullYear();
          const mes = String(dataDoPedido.getMonth() + 1).padStart(2, '0');
          const dia = String(dataDoPedido.getDate()).padStart(2, '0');
          dataFormatada = `${ano}-${mes}-${dia}`;
        } else {
          dataFormatada = String(dataDoPedido).split(' ')[0].split('T')[0];
        }
        return dataFormatada >= inicio && dataFormatada <= fim;
      } catch (e) {
        return false;
      }
    },

    async $_buscarVendedorLogado() {
      try {
        const paramsDb = await db.parametro.toArray();
        if (paramsDb.length > 0) {
          const param = paramsDb[0];
          this.idVendedorLogado = param.idvendedorlogado;
          
          const registroEmpresa = await db.empresa.limit(1).first();
          if (registroEmpresa && (registroEmpresa.idEmpresa || registroEmpresa.idempresa)) {
            this.idEmpresaLogada = Number(registroEmpresa.idEmpresa || registroEmpresa.idempresa);
          } else {
            this.idEmpresaLogada = param.empresa ? parseInt(param.empresa) : 1;
          }
          if (isNaN(this.idEmpresaLogada)) {
            this.idEmpresaLogada = 1;
          }
        }
      } catch (e) {
        console.error("Erro ao recuperar vendedor logado:", e);
      }
    },

    async $_setupIdUsuario() {
      const storageData = await getSessionStorage(TOKEN, null);
      if (!storageData) return;

      const token = JSON.parse(storageData);
      
      if (token && token.userId) {
          const vendedor = await db.vendedor.toCollection().first(); 

          if (vendedor) {
              const idVendedor = vendedor.idvendedor || vendedor.IdVendedor || vendedor.id;
              sessionStorage.setItem(VENDEDOR_STORAGE.venidvendedor, idVendedor);
          }
      }
    },

    async $_carregarTotalPedidos() {
      try {
        const pedidos = await db.pedido
          .where('idvendedor').equals(Number(this.idVendedorLogado))
          .and(pedido => {
            const temId = pedido.idpedidoback !== null && pedido.idpedidoback !== undefined && pedido.idpedidoback !== '';
            const noPeriodo = this.$_dentroDoPeriodo(pedido, 'data');
            const pertenceAEmpresa = !pedido.idempresa || Number(pedido.idempresa) === Number(this.idEmpresaLogada);

            return temId && noPeriodo && pertenceAEmpresa;
          })
          .toArray();
        this.dashboard.totalPedidos = pedidos.length;

        const valorTotal = pedidos.reduce((acumulador, pedido) => {
          let totalString = String(pedido.total || '0').replace(',', '.');
          return acumulador + (parseFloat(totalString) || 0);
        }, 0);

        this.dashboard.valorTotalPedidos = new Intl.NumberFormat('pt-BR', {
          style: 'decimal',
          minimumFractionDigits: 2,
          maximumFractionDigits: 2
        }).format(valorTotal);

      } catch (error) {
        console.error('Erro ao buscar total de pedidos no Dexie:', error);
      }
    },

    async $_carregarPedidosFaturados() {
      try {
        const pedidosFaturados = await db.pedido
          .where('idvendedor').equals(Number(this.idVendedorLogado))
          .and(pedido => {
            const faturado = pedido.datafaturamento !== null && pedido.datafaturamento !== undefined && pedido.datafaturamento !== '';
            const noPeriodo = this.$_dentroDoPeriodo(pedido, 'data');
            const pertenceAEmpresa = !pedido.idempresa || Number(pedido.idempresa) === Number(this.idEmpresaLogada);

            return faturado && noPeriodo && pertenceAEmpresa;
          })
          .toArray(); 

        this.dashboard.faturados = pedidosFaturados.length;

        const valorTotal = pedidosFaturados.reduce((acumulador, pedido) => {
          let totalString = String(pedido.total || '0').replace(',', '.');
          return acumulador + (parseFloat(totalString) || 0);
        }, 0);

        this.dashboard.valorFaturados = new Intl.NumberFormat('pt-BR', {
          style: 'decimal',
          minimumFractionDigits: 2,
          maximumFractionDigits: 2
        }).format(valorTotal);
      } catch (error) {
        console.error('Erro ao buscar pedidos faturados no Dexie:', error);
      }
    }, 

    async $_carregarTotalOrcamento() {
      try {
        const pedidos = await db.pedido
          .where('idvendedor').equals(Number(this.idVendedorLogado))
          .and(pedido => {
            const temIdOrcamento = pedido.idorcamentoback !== null && pedido.idorcamentoback !== undefined && pedido.idorcamentoback !== '';
            const ehOrcamento = pedido.orcamento == 1 || pedido.orcamento === '1' || temIdOrcamento;
            const noPeriodo = this.$_dentroDoPeriodo(pedido, 'data');
            const pertenceAEmpresa = !pedido.idempresa || Number(pedido.idempresa) === Number(this.idEmpresaLogada);
            const naoCancelado = !pedido.datacancelamento && pedido.cancelado !== 'S';
            const naoLimpo = !pedido.datalimpeza;
            
            return ehOrcamento && noPeriodo && pertenceAEmpresa && naoCancelado && naoLimpo;
          })
          .toArray();
        this.dashboard.totalOrcamento = pedidos.length;

        const valorTotal = pedidos.reduce((acumulador, pedido) => {
          let totalString = String(pedido.total || '0').replace(',', '.');
          return acumulador + (parseFloat(totalString) || 0);
        }, 0);

        this.dashboard.valorTotalOrcamento = new Intl.NumberFormat('pt-BR', {
          style: 'decimal',
          minimumFractionDigits: 2,
          maximumFractionDigits: 2
        }).format(valorTotal);

      } catch (error) {
        console.error('Erro ao buscar total de pedidos no Dexie:', error);
      }
    },

    async $_carregarOrcamentoConvertido() {
      try {
        const pedidosFaturados = await db.pedido
          .where('idvendedor').equals(Number(this.idVendedorLogado))
          .and(pedido => {
            const temIdOrcamento = pedido.idorcamentoback !== null && pedido.idorcamentoback !== undefined && pedido.idorcamentoback !== '';
            const temIdPedido = pedido.idpedidoback !== null && pedido.idpedidoback !== undefined && pedido.idpedidoback !== '';
            const ehConvertido = temIdOrcamento && temIdPedido;
            const campoData = pedido.dataconversao || pedido.data;
            const noPeriodo = this.$_dentroDoPeriodo(pedido, campoData === pedido.dataconversao ? 'dataconversao' : 'data');
            const pertenceAEmpresa = !pedido.idempresa || Number(pedido.idempresa) === Number(this.idEmpresaLogada);
            const naoCancelado = !pedido.datacancelamento && pedido.cancelado !== 'S';
            const naoLimpo = !pedido.datalimpeza;

            return ehConvertido && noPeriodo && pertenceAEmpresa && naoCancelado && naoLimpo;
          })
          .toArray(); 

        this.dashboard.orcamentoConvertido = pedidosFaturados.length;

        const valorTotal = pedidosFaturados.reduce((acumulador, pedido) => {
          let totalString = String(pedido.total || '0').replace(',', '.');
          return acumulador + (parseFloat(totalString) || 0);
        }, 0);

        this.dashboard.valorOrcamentoConvertido = new Intl.NumberFormat('pt-BR', {
          style: 'decimal',
          minimumFractionDigits: 2,
          maximumFractionDigits: 2
        }).format(valorTotal);
      } catch (error) {
        console.error('Erro ao buscar pedidos faturados no Dexie:', error);
      }
    }, 

    async $_carregarTicketMedio() {
      try {
        const pedidosTotais = await db.pedido
          .where('idvendedor').equals(Number(this.idVendedorLogado))
          .and(pedido => {
            const temId = pedido.idpedidoback !== null && pedido.idpedidoback !== undefined && pedido.idpedidoback !== '';
            const noPeriodo = this.$_dentroDoPeriodo(pedido, 'data');
            const pertenceAEmpresa = !pedido.idempresa || Number(pedido.idempresa) === Number(this.idEmpresaLogada);

            return temId && noPeriodo && pertenceAEmpresa;
          })
          .toArray();

        const quantidade = pedidosTotais.length;
        if (quantidade === 0) {
          this.dashboard.ticketMedio = '0,00';
          return;
        }

        const somaTotal = pedidosTotais.reduce((acumulador, pedido) => {
          let totalString = String(pedido.total || '0').replace(',', '.');
          const valorPedido = parseFloat(totalString) || 0;
          return acumulador + valorPedido;
        }, 0);

        const media = somaTotal / quantidade;

        this.dashboard.ticketMedio = new Intl.NumberFormat('pt-BR', {
          style: 'decimal',
          minimumFractionDigits: 2,
          maximumFractionDigits: 2
        }).format(media);

      } catch (error) {
        console.error('Erro ao calcular o Ticket Médio no Dexie:', error);
      }
    },

    async $_carregarMetaMensal() {
      try {
        let valorMeta = 0;

        if (this.idVendedorLogado) {
          const vendedores = await db.vendedor.toArray();
          const vendedorLogado = vendedores.find(v => 
            String(v.idvendedor) === String(this.idVendedorLogado) || 
            String(v.IdVendedor) === String(this.idVendedorLogado) || 
            String(v.id) === String(this.idVendedorLogado)
          );

          if (vendedorLogado) {
            let metaString = String(vendedorLogado.valormeta || '0').replace(',', '.');
            valorMeta = parseFloat(metaString) || 0;
          }
        }

        const pedidosTotais = await db.pedido
          .filter(pedido => {
            const pertenceAoVendedor = String(pedido.idvendedor) === String(this.idVendedorLogado);
            const temId = pedido.idpedidoback !== null && pedido.idpedidoback !== undefined && pedido.idpedidoback !== '';
            const noPeriodo = this.$_dentroDoPeriodo(pedido, 'data');
            const pertenceAEmpresa = !pedido.idempresa || Number(pedido.idempresa) === Number(this.idEmpresaLogada);

            return pertenceAoVendedor && temId && noPeriodo && pertenceAEmpresa;
          })
          .toArray();

        const valorRealizado = pedidosTotais.reduce((acumulador, pedido) => {
          let totalString = String(pedido.total || '0').replace(',', '.');
          return acumulador + (parseFloat(totalString) || 0);
        }, 0);

        let percentual = 0;
        if (valorMeta > 0) {
          percentual = Math.round((valorRealizado / valorMeta) * 100);
        }

        const formatadorMoeda = new Intl.NumberFormat('pt-BR', {
          style: 'decimal',
          minimumFractionDigits: 2,
          maximumFractionDigits: 2
        });

        this.dashboard.metaValor = formatadorMoeda.format(valorMeta);
        this.dashboard.realizadoValor = formatadorMoeda.format(valorRealizado);
        this.dashboard.metaPercentual = percentual;

      } catch (error) {
        console.error('Erro ao calcular a Meta Mensal no Dexie:', error);
      }
    },

    async $_carregarPedidosAFaturar() {
      try {
        const pedidosAFaturar = await db.pedido
          .where('idvendedor').equals(Number(this.idVendedorLogado))
          .and(pedido => {
            const temId = pedido.idpedidoback !== null && pedido.idpedidoback !== undefined && pedido.idpedidoback !== '';
            const naoFaturado = pedido.datafaturamento === null || pedido.datafaturamento === undefined || pedido.datafaturamento === '';
            const naoCancelado = pedido.datacancelamento === null || pedido.datacancelamento === undefined || pedido.datacancelamento === '';
            const noPeriodo = this.$_dentroDoPeriodo(pedido, 'data');
            const pertenceAEmpresa = !pedido.idempresa || Number(pedido.idempresa) === Number(this.idEmpresaLogada);
            return temId && naoFaturado && naoCancelado && noPeriodo && pertenceAEmpresa;
          })
          .toArray();

        this.dashboard.aFaturar = pedidosAFaturar.length;

        const valorTotal = pedidosAFaturar.reduce((acumulador, pedido) => {
          let totalString = String(pedido.total || '0').replace(',', '.');
          return acumulador + (parseFloat(totalString) || 0);
        }, 0);

        this.dashboard.valorAFaturar = new Intl.NumberFormat('pt-BR', {
          style: 'decimal',
          minimumFractionDigits: 2,
          maximumFractionDigits: 2
        }).format(valorTotal);
      } catch (error) {
        console.error('Erro ao buscar pedidos a faturar no Dexie:', error);
      }
    },

    async $_carregarOrcamentosAConverter() {
      try {
        const orcamentosAConverter = await db.pedido
          .where('idvendedor').equals(Number(this.idVendedorLogado))
          .and(pedido => {
            const temIdOrcamento = pedido.idorcamentoback !== null && pedido.idorcamentoback !== undefined && pedido.idorcamentoback !== '';
            const ehOrcamento = pedido.orcamento == 1 || pedido.orcamento === '1' || temIdOrcamento;
            const temIdPedido = pedido.idpedidoback !== null && pedido.idpedidoback !== undefined && pedido.idpedidoback !== '';
            const ehAConverter = ehOrcamento && !temIdPedido;
            const naoCancelado = pedido.datacancelamento === null || pedido.datacancelamento === undefined || pedido.datacancelamento === '';
            const noPeriodo = this.$_dentroDoPeriodo(pedido, 'data');
            const pertenceAEmpresa = !pedido.idempresa || Number(pedido.idempresa) === Number(this.idEmpresaLogada);
            return ehAConverter && naoCancelado && noPeriodo && pertenceAEmpresa;
          })
          .toArray();

        this.dashboard.aConverter = orcamentosAConverter.length;

        const valorTotal = orcamentosAConverter.reduce((acumulador, pedido) => {
          let totalString = String(pedido.total || '0').replace(',', '.');
          return acumulador + (parseFloat(totalString) || 0);
        }, 0);

        this.dashboard.valorAConverter = new Intl.NumberFormat('pt-BR', {
          style: 'decimal',
          minimumFractionDigits: 2,
          maximumFractionDigits: 2
        }).format(valorTotal);
      } catch (error) {
        console.error('Erro ao buscar orçamentos a converter no Dexie:', error);
      }
    },

    async $_carregarMetricasClientes() {
      try {
        const idVen = Number(this.idVendedorLogado);
        if (!idVen) return;

        const createdFrom = getQueryValue(HOME_QUERIES.createdFrom);
        const createdBefore = getQueryValue(HOME_QUERIES.createdBefore);

        const dataAtual = new Date();
        const hoje = dataAtual.toISOString().split('T')[0];
        const ano = dataAtual.getFullYear();
        const mes = String(dataAtual.getMonth() + 1).padStart(2, '0');
        const primeiroDiaMes = `${ano}-${mes}-01`;

        const inicio = createdFrom || primeiroDiaMes;
        const fim = createdBefore || hoje;

        const inicioTime = new Date(`${inicio}T00:00:00`).getTime();
        const fimTime = new Date(`${fim}T23:59:59`).getTime();

        const obterDateObjeto = (data) => {
          if (!data) return null;
          try {
            if (data instanceof Date) {
              if (isNaN(data.getTime())) return null;
              return data;
            }
            if (typeof data === 'string') {
              if (data.includes('/')) {
                const partes = data.split(' ');
                const partesData = partes[0].split('/');
                if (partesData.length === 3) {
                  const dataFormatada = `${partesData[2]}-${partesData[1].padStart(2, '0')}-${partesData[0].padStart(2, '0')}`;
                  const horaFormatada = partes[1] || '00:00:00';
                  const d = new Date(`${dataFormatada}T${horaFormatada}`);
                  if (!isNaN(d.getTime())) return d;
                }
              }
              let str = data;
              if (/^\d{4}-\d{2}-\d{2}$/.test(str)) {
                str += 'T00:00:00';
              }
              const d = new Date(str);
              if (!isNaN(d.getTime())) return d;
            }
            const d = new Date(data);
            if (!isNaN(d.getTime())) return d;
            return null;
          } catch (e) {
            return null;
          }
        };

        const todosClientes = await db.cliente.toArray();
        const clientesDoVendedor = todosClientes.filter(c => Number(c.idvendedor) === idVen);

        const vendasDoVendedor = await db.venda
          .where('idvendedor')
          .equals(idVen)
          .toArray();

        const vendasFiltradas = vendasDoVendedor.filter(v => {
          const dtObj = obterDateObjeto(v.data);
          if (!dtObj) return false;
          const time = dtObj.getTime();
          const dentroDoPeriodo = time >= inicioTime && time <= fimTime;
          const pertenceAEmpresa = !v.idempresa || Number(v.idempresa) === Number(this.idEmpresaLogada);
          const naoCancelado = v.cancelado !== 'S';
          return dentroDoPeriodo && pertenceAEmpresa && naoCancelado;
        });

        const clientesComVendaNoPeriodo = new Set(vendasFiltradas.map(v => Number(v.idcliente)));

        const pedidosDoVendedor = await db.pedido
          .where('idvendedor')
          .equals(idVen)
          .toArray();

        pedidosDoVendedor.forEach(p => {
          const dtObj = obterDateObjeto(p.data);
          if (dtObj) {
            const time = dtObj.getTime();
            const dentroDoPeriodo = time >= inicioTime && time <= fimTime;
            const pertenceAEmpresa = !p.idempresa || Number(p.idempresa) === Number(this.idEmpresaLogada);
            const naoCancelado = !p.datacancelamento && p.cancelado !== 'S';
            if (dentroDoPeriodo && pertenceAEmpresa && naoCancelado) {
              clientesComVendaNoPeriodo.add(Number(p.idcliente));
            }
          }
        });

        const novos = clientesDoVendedor.filter(c => {
          const dtObj = obterDateObjeto(c.DataCadastro || c.datacadastro);
          if (!dtObj) return false;
          const time = dtObj.getTime();
          return time >= inicioTime && time <= fimTime;
        });
        this.dashboard.clientesNovos = novos.length;

        const novosComVenda = novos.filter(c => clientesComVendaNoPeriodo.has(Number(c.idcliente)));
        this.dashboard.clientesNovosComVenda = novosComVenda.length;

        const ativos = clientesDoVendedor.filter(c => {
          const dtCadObj = obterDateObjeto(c.DataCadastro || c.datacadastro);
          const dtInativoObj = obterDateObjeto(c.DATAINATIVO || c.datainativo);

          const cadTime = dtCadObj ? dtCadObj.getTime() : 0;
          const inativoTime = dtInativoObj ? dtInativoObj.getTime() : null;

          const cadastradoAteFim = cadTime <= fimTime;
          const ativoNoPeriodo = inativoTime === null || inativoTime > fimTime;

          return cadastradoAteFim && ativoNoPeriodo;
        });
        this.dashboard.carteiraAtiva = ativos.length;

        const ativosComVenda = ativos.filter(c => clientesComVendaNoPeriodo.has(Number(c.idcliente)));
        
        this.dashboard.carteiraComVenda = ativosComVenda.length;

        this.dashboard.carteiraSemVenda = this.dashboard.carteiraAtiva - this.dashboard.carteiraComVenda;

      } catch (error) {
        console.error('Erro ao carregar métricas de clientes no Dexie:', error);
      }
    },

    async $_carregarVendasPorCidade() {
      try {
        const idVen = Number(this.idVendedorLogado);
        if (!idVen) return;

        const createdFrom = getQueryValue(HOME_QUERIES.createdFrom);
        const createdBefore = getQueryValue(HOME_QUERIES.createdBefore);

        const dataAtual = new Date();
        const hoje = dataAtual.toISOString().split('T')[0];
        const ano = dataAtual.getFullYear();
        const mes = String(dataAtual.getMonth() + 1).padStart(2, '0');
        const primeiroDiaMes = `${ano}-${mes}-01`;

        const inicio = createdFrom || primeiroDiaMes;
        const fim = createdBefore || hoje;

        const inicioTime = new Date(`${inicio}T00:00:00`).getTime();
        const fimTime = new Date(`${fim}T23:59:59`).getTime();

        const obterDateObjeto = (data) => {
          if (!data) return null;
          try {
            if (data instanceof Date) {
              if (isNaN(data.getTime())) return null;
              return data;
            }
            if (typeof data === 'string') {
              if (data.includes('/')) {
                const partes = data.split(' ');
                const partesData = partes[0].split('/');
                if (partesData.length === 3) {
                  const dataFormatada = `${partesData[2]}-${partesData[1].padStart(2, '0')}-${partesData[0].padStart(2, '0')}`;
                  const horaFormatada = partes[1] || '00:00:00';
                  const d = new Date(`${dataFormatada}T${horaFormatada}`);
                  if (!isNaN(d.getTime())) return d;
                }
              }
              let str = data;
              if (/^\d{4}-\d{2}-\d{2}$/.test(str)) {
                str += 'T00:00:00';
              }
              const d = new Date(str);
              if (!isNaN(d.getTime())) return d;
            }
            const d = new Date(data);
            if (!isNaN(d.getTime())) return d;
            return null;
          } catch (e) {
            return null;
          }
        };

        const todosClientes = await db.cliente.toArray();
        const clientMap = new Map();
        todosClientes.forEach(c => {
          clientMap.set(Number(c.idcliente), c);
          clientMap.set(String(c.idcliente), c);
        });

        const vendasDoVendedor = await db.venda
          .where('idvendedor')
          .equals(idVen)
          .toArray();

        const vendasFiltradas = vendasDoVendedor.filter(v => {
          const dtObj = obterDateObjeto(v.data);
          if (!dtObj) return false;
          const time = dtObj.getTime();
          const dentroDoPeriodo = time >= inicioTime && time <= fimTime;
          const pertenceAEmpresa = !v.idempresa || Number(v.idempresa) === Number(this.idEmpresaLogada);
          const naoCancelado = v.cancelado !== 'S';
          return dentroDoPeriodo && pertenceAEmpresa && naoCancelado;
        });

        const agrupamento = {};
        const vendasProcessadas = new Set();

        const obterNomeCidadeNormalizado = (cidadeRaw) => {
          const cidade = (cidadeRaw || '').trim();
          if (!cidade) return 'Indefinida';
          return cidade.toLowerCase().replace(/(?:^|\s)\S/g, a => a.toUpperCase());
        };

        vendasFiltradas.forEach(venda => {
          const cliente = clientMap.get(Number(venda.idcliente)) || clientMap.get(String(venda.idcliente));
          const cidadeNome = obterNomeCidadeNormalizado(venda.cidade || (cliente ? cliente.cidade : 'Indefinida'));
          const idVenda = venda.idvenda;

          const chave = `${cidadeNome}_${idVenda}`;
          if (!vendasProcessadas.has(chave)) {
            vendasProcessadas.add(chave);

            let totalString = String(venda.vlrliquidovenda || venda.valor || '0').replace(',', '.');
            const valorVenda = parseFloat(totalString) || 0;

            if (!agrupamento[cidadeNome]) {
              agrupamento[cidadeNome] = 0;
            }
            agrupamento[cidadeNome] += valorVenda;
          }
        });

        const listaCidades = Object.keys(agrupamento).map(cidade => ({
          nome: cidade,
          valor: agrupamento[cidade],
        }));

        listaCidades.sort((a, b) => b.valor - a.valor);

        const totalGeral = listaCidades.reduce((acc, c) => acc + c.valor, 0);

        const formatadorMoeda = new Intl.NumberFormat('pt-BR', {
          style: 'decimal',
          minimumFractionDigits: 2,
          maximumFractionDigits: 2
        });

        const coresPaleta = [
          '#4c6faf', '#10B981', '#F59E0B', '#EF4444', '#8B5CF6',
          '#EC4899', '#06B6D4', '#F97316', '#14B8A6', '#6366F1',
          '#84CC16', '#D946EF', '#3B82F6', '#EAB308', '#64748B',
          '#0D9488', '#E11D48', '#2563EB', '#A855F7', '#F43F5E'
        ];

        const todosItens = listaCidades.map((item, index) => {
          const percentual = totalGeral > 0 ? (item.valor / totalGeral) * 100 : 0;
          return {
            ...item,
            posicao: index + 1,
            percentual: percentual.toFixed(1),
            percentualNum: percentual,
            valorFormatado: formatadorMoeda.format(item.valor),
            cor: coresPaleta[index % coresPaleta.length]
          };
        });

        this.dashboardCidades = {
          totalGeral: formatadorMoeda.format(totalGeral),
          qtdCidades: listaCidades.length,
          itens: todosItens,
          itensVerticais: todosItens
        };

      } catch (error) {
        console.error('Erro ao carregar vendas por cidade no Dexie:', error);
      }
    },

    async $_carregarVendasPorGrupo() {
      try {
        const idVen = Number(this.idVendedorLogado);
        if (!idVen) return;

        const createdFrom = getQueryValue(HOME_QUERIES.createdFrom);
        const createdBefore = getQueryValue(HOME_QUERIES.createdBefore);

        const dataAtual = new Date();
        const hoje = dataAtual.toISOString().split('T')[0];
        const ano = dataAtual.getFullYear();
        const mes = String(dataAtual.getMonth() + 1).padStart(2, '0');
        const primeiroDiaMes = `${ano}-${mes}-01`;

        const inicio = createdFrom || primeiroDiaMes;
        const fim = createdBefore || hoje;

        const inicioTime = new Date(`${inicio}T00:00:00`).getTime();
        const fimTime = new Date(`${fim}T23:59:59`).getTime();

        const obterDateObjeto = (data) => {
          if (!data) return null;
          try {
            if (data instanceof Date) {
              if (isNaN(data.getTime())) return null;
              return data;
            }
            if (typeof data === 'string') {
              if (data.includes('/')) {
                const partes = data.split(' ');
                const partesData = partes[0].split('/');
                if (partesData.length === 3) {
                  const dataFormatada = `${partesData[2]}-${partesData[1].padStart(2, '0')}-${partesData[0].padStart(2, '0')}`;
                  const horaFormatada = partes[1] || '00:00:00';
                  const d = new Date(`${dataFormatada}T${horaFormatada}`);
                  if (!isNaN(d.getTime())) return d;
                }
              }
              let str = data;
              if (/^\d{4}-\d{2}-\d{2}$/.test(str)) {
                str += 'T00:00:00';
              }
              const d = new Date(str);
              if (!isNaN(d.getTime())) return d;
            }
            const d = new Date(data);
            if (!isNaN(d.getTime())) return d;
            return null;
          } catch (e) {
            return null;
          }
        };

        const vendasDoVendedor = await db.venda
          .where('idvendedor')
          .equals(idVen)
          .toArray();

        const vendasFiltradas = vendasDoVendedor.filter(v => {
          const dtObj = obterDateObjeto(v.data);
          if (!dtObj) return false;
          const time = dtObj.getTime();
          const dentroDoPeriodo = time >= inicioTime && time <= fimTime;
          const pertenceAEmpresa = !v.idempresa || Number(v.idempresa) === Number(this.idEmpresaLogada);
          const naoCancelado = v.cancelado !== 'S';
          return dentroDoPeriodo && pertenceAEmpresa && naoCancelado;
        });

        if (vendasFiltradas.length === 0) {
          this.dashboardGrupos = {
            totalGeral: '0,00',
            qtdGrupos: 0,
            itens: [],
            itensVerticais: []
          };
          return;
        }

        const idsProdutos = new Set();
        vendasFiltradas.forEach(v => {
          if (v.idcortamanhofinal) {
            idsProdutos.add(parseInt(v.idcortamanhofinal));
          }
        });

        const arrayIds = Array.from(idsProdutos);

        const produtos = await db.produto
          .where('idcortamanhofinal')
          .anyOf(arrayIds)
          .toArray();

        const mapaProdutoGrupo = {};
        produtos.forEach(p => {
          const idProd = parseInt(p.idcortamanhofinal);
          const idG = p.idgrupo || 999;
          const descG = p.descricaogrupo || (p.idgrupo ? `Grupo ${p.idgrupo}` : 'Sem Grupo');

          mapaProdutoGrupo[idProd] = {
            id: idG,
            descricao: descG
          };
        });

        const agrupamento = {};
        let totalGeral = 0;

        const normalizarNomeGrupo = (desc) => {
          if (!desc) return 'Sem Grupo';
          return desc.trim().toLowerCase().replace(/(?:^|\s)\S/g, a => a.toUpperCase());
        };

        vendasFiltradas.forEach(venda => {
          const idProd = parseInt(venda.idcortamanhofinal);
          let totalString = String(venda.valor || venda.vlrliquidovenda || '0').replace(',', '.');
          const valor = parseFloat(totalString) || 0;

          const dadosGrupo = mapaProdutoGrupo[idProd] || {
            id: 0,
            descricao: `Não Identificado`
          };

          const idChave = dadosGrupo.id;
          const nomeFormatado = normalizarNomeGrupo(dadosGrupo.descricao);

          if (!agrupamento[idChave]) {
            agrupamento[idChave] = {
              idgrupo: idChave,
              descricao: nomeFormatado,
              valor: 0
            };
          }

          agrupamento[idChave].valor += valor;
          totalGeral += valor;
        });

        const listaGrupos = Object.values(agrupamento);
        listaGrupos.sort((a, b) => b.valor - a.valor);

        const formatadorMoeda = new Intl.NumberFormat('pt-BR', {
          style: 'decimal',
          minimumFractionDigits: 2,
          maximumFractionDigits: 2
        });

        const formatarAbreviado = (valor) => {
          if (valor >= 1000000) {
            return ` ${(valor / 1000000).toFixed(1).replace('.', ',')}M`;
          }
          if (valor >= 1000) {
            return ` ${(valor / 1000).toFixed(1).replace('.', ',')}k`;
          }
          return ` ${Math.round(valor)}`;
        };

        const encurtarNome = (nome) => {
          if (!nome) return '';
          if (nome.length <= 11) return nome;
          const partes = nome.split(' ');
          if (partes.length > 1) {
            if (partes[0].length <= 3) {
              return `${partes[0]} ${partes[1].substring(0, 6)}.`;
            }
            return `${partes[0]} ${partes[1][0]}.`;
          }
          return `${nome.substring(0, 9)}...`;
        };

        const coresPaleta = [
          '#6366F1', '#EC4899', '#10B981', '#F59E0B', '#06B6D4',
          '#8B5CF6', '#F97316', '#14B8A6', '#2563EB', '#84CC16',
          '#E11D48', '#D97706', '#3B82F6', '#10B981', '#64748B',
          '#0D9488', '#EAB308', '#A855F7', '#F43F5E', '#4c6faf'
        ];

        // Todos os grupos para Barras Verticais
        const maxValor = listaGrupos.length > 0 ? listaGrupos[0].valor : 0;

        const itensVerticais = listaGrupos.map((item, index) => {
          const percentual = totalGeral > 0 ? (item.valor / totalGeral) * 100 : 0;
          const alturaRelativa = maxValor > 0 ? Math.max(10, Math.round((item.valor / maxValor) * 100)) : 10;
          return {
            ...item,
            nome: item.descricao,
            posicao: index + 1,
            nomeCurto: encurtarNome(item.descricao),
            percentual: percentual.toFixed(1),
            percentualNum: percentual,
            alturaRelativa: alturaRelativa,
            valorFormatado: formatadorMoeda.format(item.valor),
            valorAbreviado: formatarAbreviado(item.valor),
            cor: coresPaleta[index % coresPaleta.length]
          };
        });

        this.dashboardGrupos = {
          totalGeral: formatadorMoeda.format(totalGeral),
          qtdGrupos: listaGrupos.length,
          itens: itensVerticais,
          itensVerticais: itensVerticais
        };

      } catch (error) {
        console.error('Erro ao carregar vendas por grupo no Dexie:', error);
      }
    },

    async $_carregarVendasPorMarca() {
      try {
        const idVen = Number(this.idVendedorLogado);
        if (!idVen) return;

        const createdFrom = getQueryValue(HOME_QUERIES.createdFrom);
        const createdBefore = getQueryValue(HOME_QUERIES.createdBefore);

        const dataAtual = new Date();
        const hoje = dataAtual.toISOString().split('T')[0];
        const ano = dataAtual.getFullYear();
        const mes = String(dataAtual.getMonth() + 1).padStart(2, '0');
        const primeiroDiaMes = `${ano}-${mes}-01`;

        const inicio = createdFrom || primeiroDiaMes;
        const fim = createdBefore || hoje;

        const inicioTime = new Date(`${inicio}T00:00:00`).getTime();
        const fimTime = new Date(`${fim}T23:59:59`).getTime();

        const obterDateObjeto = (data) => {
          if (!data) return null;
          try {
            if (data instanceof Date) {
              if (isNaN(data.getTime())) return null;
              return data;
            }
            if (typeof data === 'string') {
              if (data.includes('/')) {
                const partes = data.split(' ');
                const partesData = partes[0].split('/');
                if (partesData.length === 3) {
                  const dataFormatada = `${partesData[2]}-${partesData[1].padStart(2, '0')}-${partesData[0].padStart(2, '0')}`;
                  const horaFormatada = partes[1] || '00:00:00';
                  const d = new Date(`${dataFormatada}T${horaFormatada}`);
                  if (!isNaN(d.getTime())) return d;
                }
              }
              let str = data;
              if (/^\d{4}-\d{2}-\d{2}$/.test(str)) {
                str += 'T00:00:00';
              }
              const d = new Date(str);
              if (!isNaN(d.getTime())) return d;
            }
            const d = new Date(data);
            if (!isNaN(d.getTime())) return d;
            return null;
          } catch (e) {
            return null;
          }
        };

        const vendasDoVendedor = await db.venda
          .where('idvendedor')
          .equals(idVen)
          .toArray();

        const vendasFiltradas = vendasDoVendedor.filter(v => {
          const dtObj = obterDateObjeto(v.data);
          if (!dtObj) return false;
          const time = dtObj.getTime();
          const dentroDoPeriodo = time >= inicioTime && time <= fimTime;
          const pertenceAEmpresa = !v.idempresa || Number(v.idempresa) === Number(this.idEmpresaLogada);
          const naoCancelado = v.cancelado !== 'S';
          return dentroDoPeriodo && pertenceAEmpresa && naoCancelado;
        });

        if (vendasFiltradas.length === 0) {
          this.dashboardMarcas = {
            totalGeral: '0,00',
            qtdMarcas: 0,
            itens: [],
            itensVerticais: []
          };
          return;
        }

        const idsProdutos = new Set();
        vendasFiltradas.forEach(v => {
          if (v.idcortamanhofinal) {
            idsProdutos.add(parseInt(v.idcortamanhofinal));
          }
        });

        const arrayIds = Array.from(idsProdutos);

        const produtos = await db.produto
          .where('idcortamanhofinal')
          .anyOf(arrayIds)
          .toArray();

        const mapaProdutoMarca = {};
        produtos.forEach(p => {
          const idProd = parseInt(p.idcortamanhofinal);
          const marcaNome = (p.marca || p.Marca || '').trim() || 'Sem Marca';
          mapaProdutoMarca[idProd] = marcaNome;
        });

        const agrupamento = {};
        let totalGeral = 0;

        const normalizarNomeMarca = (desc) => {
          if (!desc || desc.trim() === '') return 'Sem Marca';
          return desc.trim().toLowerCase().replace(/(?:^|\s)\S/g, a => a.toUpperCase());
        };

        vendasFiltradas.forEach(venda => {
          const idProd = parseInt(venda.idcortamanhofinal);
          let totalString = String(venda.valor || venda.vlrliquidovenda || '0').replace(',', '.');
          const valor = parseFloat(totalString) || 0;

          const nomeMarcaRaw = mapaProdutoMarca[idProd] || 'Sem Marca';
          const nomeMarca = normalizarNomeMarca(nomeMarcaRaw);

          if (!agrupamento[nomeMarca]) {
            agrupamento[nomeMarca] = {
              nome: nomeMarca,
              valor: 0
            };
          }

          agrupamento[nomeMarca].valor += valor;
          totalGeral += valor;
        });

        const listaMarcas = Object.values(agrupamento);
        listaMarcas.sort((a, b) => b.valor - a.valor);

        const formatadorMoeda = new Intl.NumberFormat('pt-BR', {
          style: 'decimal',
          minimumFractionDigits: 2,
          maximumFractionDigits: 2
        });

        const coresPaleta = [
          '#0D9488', '#E11D48', '#3B82F6', '#D97706', '#8B5CF6',
          '#10B981', '#06B6D4', '#F97316', '#6366F1', '#EC4899',
          '#84CC16', '#2563EB', '#F43F5E', '#14B8A6', '#64748B',
          '#4c6faf', '#EAB308', '#A855F7', '#10B981', '#D946EF'
        ];

        // Todas as marcas para Barras Horizontais
        const todosItens = listaMarcas.map((item, index) => {
          const percentual = totalGeral > 0 ? (item.valor / totalGeral) * 100 : 0;
          return {
            ...item,
            posicao: index + 1,
            percentual: percentual.toFixed(1),
            percentualNum: percentual,
            valorFormatado: formatadorMoeda.format(item.valor),
            cor: coresPaleta[index % coresPaleta.length]
          };
        });

        this.dashboardMarcas = {
          totalGeral: formatadorMoeda.format(totalGeral),
          qtdMarcas: listaMarcas.length,
          itens: todosItens,
          itensVerticais: todosItens
        };

      } catch (error) {
        console.error('Erro ao carregar vendas por marca no Dexie:', error);
      }
    }
  },

  async created() {
    await this.$_buscarVendedorLogado(); 
    this.$_setupIdUsuario();
    if (this.$route.query[HOME_QUERIES.createdFrom]) {
      this.$_recarregarDashboard();
    }
  },
};
</script>

<style scoped>
.position-relative {
  position: relative;
}
.overflow-hidden {
  overflow: hidden;
}
.z-index-1 {
  z-index: 1;
  position: relative;
}
.gap-4 {
  gap: 16px;
}

.dashboard-card, .ticket-card, .hover-card, .dashboard-card-amber, .dashboard-card-teal {
  transition: transform 0.3s ease, box-shadow 0.3s ease;
}

.dashboard-card:hover, .hover-card:hover, .dashboard-card-amber:hover, .dashboard-card-teal:hover {
  transform: translateY(-1px);
  box-shadow: 0 8px 16px rgba(0,0,0,0.08) !important;
}

.ticket-card:hover {
  transform: translateY(-1px);
  box-shadow: 0 10px 20px rgba(30, 58, 138, 0.3) !important;
}

.dashboard-card {
  background-color: #ffffff;
  border: none;
  border-left: 5px solid #4c6faf;
}

.dashboard-card-amber {
  background-color: #ffffff;
  border: none;
  border-left: 5px solid #ffa000 ;
}

.dashboard-card-teal {
  background-color: #ffffff;
  border: none;
  border-left: 5px solid #009688 ;
}

.watermark-icon {
  position: absolute !important;
  right: -10px;
  bottom: -15px;
  font-size: 80px !important;
  opacity: 0.05;
  color: #1e293b !important;
  transform: rotate(-10deg);
  pointer-events: none;
}

.ticket-watermark {
  position: absolute !important;
  right: 10px;
  top: 50%;
  transform: translateY(-50%) scale(2.5) rotate(-15deg);
  font-size: 60px !important;
  opacity: 0.15;
  color: white !important;
  pointer-events: none;
}

.ticket-card {
  background: linear-gradient(135deg, #1e3a8a 0%, #4c6faf 100%) !important;
}

.progress-bg :deep(.v-progress-circular__underlay) {
  stroke: #dee2e6;
}

.section-banner {
  font-size: 0.85rem;
  letter-spacing: 0.5px;
  display: flex;
  align-center: center;
}

.banner-blue {
  background-color: #4c6faf;
}

.banner-amber {
  background-color: #ffa000;
}

.banner-teal {
  background-color: #009688;
}

.rank-badge {
  display: inline-flex;
  align-items: center;
  justify-content: center;
  width: 20px;
  height: 20px;
  border-radius: 50%;
  color: #ffffff;
  font-size: 0.72rem;
  font-weight: 700;
  flex-shrink: 0;
}

.donut-chart-wrapper {
  position: relative;
  display: flex;
  justify-content: center;
  align-items: center;
}

.donut-chart {
  width: 140px;
  height: 140px;
  border-radius: 50%;
  position: relative;
  display: flex;
  align-items: center;
  justify-content: center;
  box-shadow: 0 4px 12px rgba(0, 0, 0, 0.08);
  flex-shrink: 0;
  transition: transform 0.3s ease;
}

.donut-hole {
  width: 88px;
  height: 88px;
  border-radius: 50%;
  background-color: #ffffff;
  box-shadow: inset 0 2px 5px rgba(0, 0, 0, 0.06);
  padding: 4px;
}

.legend-indicator {
  width: 10px;
  height: 10px;
  border-radius: 50%;
  flex-shrink: 0;
  display: inline-block;
}

.w-100 {
  width: 100% !important;
}

.donut-legend {
  width: 100%;
  min-width: 0;
  max-height: 250px;
  align-self: stretch;
}

.donut-legend ::v-deep .simplebar-content {
  padding-right: 14px !important;
  padding-left: 6px !important;
  width: 100%;
  box-sizing: border-box;
}

.border-bottom-light {
  border-bottom: 1px solid #f1f5f9;
}

.vertical-chart-wrapper {
  width: 100%;
}

.vertical-chart-wrapper ::v-deep .simplebar-content {
  padding: 0 10px 10px 10px !important;
}

.marcas-scroll-wrapper {
  width: 100%;
  min-width: 0;
  max-height: 280px;
}

.marcas-scroll-wrapper ::v-deep .simplebar-content {
  padding-right: 14px !important;
  padding-left: 6px !important;
}

.vertical-bars-container {
  display: flex;
  align-items: flex-end;
  justify-content: flex-start;
  min-width: 100%;
  gap: 10px;
  height: 190px;
  padding-top: 15px;
}

.vertical-bar-item {
  display: flex;
  flex-direction: column;
  align-items: center;
  flex: 1 1 0;
  min-width: 54px;
  max-width: 72px;
  height: 100%;
}

.vertical-bar-val {
  font-size: 0.68rem !important;
  line-height: 1;
  margin-bottom: 5px;
  white-space: nowrap;
}

.vertical-bar-track {
  width: 100%;
  flex-grow: 1;
  background-color: #f1f5f9;
  border-radius: 6px 6px 0 0;
  display: flex;
  align-items: flex-end;
  overflow: hidden;
  position: relative;
}

.vertical-bar-fill {
  width: 100%;
  border-radius: 6px 6px 0 0;
  display: flex;
  align-items: flex-start;
  justify-content: center;
  padding-top: 4px;
  transition: height 0.4s ease-out, transform 0.2s ease;
  cursor: pointer;
}

.vertical-bar-fill:hover {
  filter: brightness(1.1);
  transform: scaleY(1.02);
}

.vertical-bar-inner-percent {
  color: #ffffff;
  font-size: 0.62rem;
  font-weight: 700;
  line-height: 1;
  text-shadow: 0 1px 2px rgba(0, 0, 0, 0.4);
}

.vertical-bar-label {
  margin-top: 6px;
  text-align: center;
  width: 100%;
  line-height: 1.1;
}

::v-deep .simplebar-scrollbar::before {
  background: rgba(76, 111, 175, 0.4) !important;
}
</style>